module.exports = __webpack_public_path__ + "assets/media/storyweaver-logo.e8ce4cf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/storyweaver-logo.svg
// module id = 912
// module chunks = 346